import generateLayerFromCapabilities from '@/composables/generate-layer-capabilities/generate-layer-capabilities'; // eslint-disable-line max-len
import {Tile as TileLayer} from 'ol/layer';

export default async function(props) {
  const source = await generateLayerFromCapabilities(props);
  if (source) {
    return new TileLayer({...props, source});
  }
  return null;
}
